import instructionWidget from '../../instruction_widgets';
import { TooltipKey } from '../../machinelogic_tooltips';

/**
 * returns a widget for selecting sequences the fsm instruction should run
 * @param {Object} params
 * @param {Object} params.application the application object
 * @param {Object} params.sequence the sequence object
 * @param {Object} params.instruction the instruction object
 * @param {() => void} params.onActionSelect callback when an action is selected
 * @param {string} params.actionSequenceName selected sequence name
 * @returns {JQuery<HTMLElement>}
 */
export const actionWidget = ({
  application,
  sequence,
  instruction,
  onActionSelect,
  actionSequenceName = ''
}) => {

  return instructionWidget.sequenceListWidget(
    "Action <span style='font-weight: normal; font-size: 12px; line-height: 0px;'>(Sequence Name)</span>",
    application,
    sequence,
    'The sequence to be invoked',
    actionSequenceName,
    onActionSelect,
    instruction.getCategory(),
    true,
    '(No Action)',
    {tooltipKey: TooltipKey.FSM_ACTION}
  );
};
